module.exports = __webpack_public_path__ + "img/y- (6).ec0bfad3.jpg";